'use strict';

require('./FormGroupDatePicker.scss');

const React = require('react'),
    PropTypes = React.PropTypes,
    ContentUtils = require('utils/ContentUtils'),
    SessionStore = require('stores/SessionStore'),
    DateUtils = require('utils/DateUtils'),
    DEFAULT_WRITTER_ATTRIBUTE = 'date',
    BasicFormGroup = require('../BasicFormGroup'),
    {DatePicker} = require('material-ui');


const FormGroupDatePicket = React.createClass({displayName: "FormGroupDatePicket",

    propTypes: Object.assign({}, BasicFormGroup.propTypes, {
        onEnter: PropTypes.func,
        label: PropTypes.string,
        onChange: PropTypes.func,
        hintText: PropTypes.string,
        formatDate: PropTypes.func,
        errorText: PropTypes.string,
        floatingLabel: PropTypes.string,
        value: PropTypes.object
    }),

    getInitialState() {
        return {
            selectedDate: ''
        };
    },

    componentDidMount() {
        const {operationsHolder} = this.props;
        // React will throw a warning for bind the context with each operation, but we need it, otherwise
        // we don't have access to the context of the component when need to perform each operation.
        operationsHolder.addValidator(this.isValid.bind(this));
        operationsHolder.addCleaner(this.clean.bind(this));
        operationsHolder.addItemProvider(this.getValue.bind(this));
    },

    _el: null,

    clean() {
        this.setState({
            selectedDate: ''
        });
    },

    isDateObj(selectedDate) {
        return typeof selectedDate === 'object';
    },

    onChange(evt, date) {
        const selectedDate = this.isDateObj(date) ? DateUtils.toDateText(date) : date;
        this.setState({
            selectedDate
        }, () => {
            if (this.props.onChange) {
                this.props.onChange();
            }
        });
    },

    _getDate() {
        const {formatDate, value} = this.props;
        const {selectedDate} = this.state;
        // internal value (should be the latest) over default value
        const date = selectedDate || value;
        return ContentUtils.isFunction(formatDate) ? formatDate(date) : date;
    },

    getValue() {
        const writterAttribute = this.props.writerAttribute || DEFAULT_WRITTER_ATTRIBUTE;
        return {[writterAttribute]: this._getDate()};
    },

    isValid(onFinishValidation) {
        let messageError = '';

        if (onFinishValidation) {
            onFinishValidation();
        }

        return messageError === '';
    },

    _onEnter() {
        if (this.props.onEnter) {
            this.props.onEnter();
        }
    },

    _onBlur() {
        if (this.props.onBlur) {
            this.isValid(this.props.onBlur);
        }
    },

    render() {
        const {floatingLabel, hintText, formatDate, errorText, disabled} = this.props;

        return (
            React.createElement("div", {className: "form-group form-group-date-picker"}, 
                React.createElement(DatePicker, {
                    floatingLabelText: floatingLabel, 
                    ref: input => this._el = input, 
                    hintText: hintText, 
                    formatDate: ContentUtils.isNull(formatDate) ? DateUtils.toDisplayDateText : formatDate, 
                    onChange: this.onChange, 
                    errorText: errorText, 
                    value: this._getDate(), 
                    disabled: disabled ? true : !SessionStore.isAdminUser(), 
                    onBlur: this.onBlur}
                )
            )
        );
    }

});

module.exports = FormGroupDatePicket;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/BasicForm/FormGroupDatePicker/FormGroupDatePicker.js
 **/